import {createRoot, hydrateRoot} from 'react-dom/client';
import AboutUs from '../pages/AboutUs/AboutUs'
import "../index.css";
import "../pages/AboutUs/AboutUs.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<AboutUs {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <AboutUs {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).AboutUsVC = {mount, hydrate, unmount}